export default {
  button: {
    add: '添加',
    back: '返回',
    cancel: '取消',
    close: '關閉',
    create: '創建',
    createAccount: '建立新帳戶',
    delete: '刪除',
    edit: '編輯',
    logout: '登出',
    ok: 'OK',
    save: '保存',
    sendResetEmail: '發送重置電子郵件',
    signup: '註冊',
    forgotPassword: '忘記密碼',
    resetPassword: '重設密碼',
    signin: '登入',
    submit: '提交',
    copy: '複製',
  },
  error: {
    appUpdateClientCredential: '應用程序無法更新客戶憑據類型，因為它已經有一個用戶',
    changePasswordUnsuccess: '修改密碼失敗。',
    create: '創建 {name} 失敗。',
    currentPassNotMatch: '密碼不一致。',
    destroy: '刪除 {name} 失敗。',
    emailWasUsed: '此電子郵件已經使用過。',
    exist: '{name} 已存在',
    expire: '{name} 已過期',
    forgotPasswordUnsuccess: '忘記密碼失敗。',
    hasMany: '{field} 已經有 {another_field}',
    lessThan: '{field} 必須少過 {another_field}',
    list: '獲取列表 {name} 失敗。',
    notExist: '{field} 不存在',
    notFound: '未找到',
    notPermission: '不允許',
    resetPasswordUnsuccess: '重置密碼失敗。',
    sessionTimeout: '活動已經逾時。請重新登入。',
    update: '更新 {name} 失敗。',
    updateProfileUnsuccess: '更新設定檔失敗。',
    used: '使用的 {name}',
    wrongEmailPassword: '電子郵件或密碼不一致。',
    accessToken: '無法成功取得使用權杖',
    lockedAccount: 'Your account is locked. Please contact with system administrator to unlock.',
    loginAuthorizationFail: '登入失敗',
    notCopyToken: '無法複製使用權杖',
    deletedUser: '您的帳戶已被刪除。請聯繫管理員',
    verifyToken: '無效的權杖',
    copyDecodeFail: '無法複製已被解碼的權杖',
    expiredResetPassword: '重置密碼的連結已過期。請您再重置密碼一次。',
    appHasClient: '這個應用程式已有客戶',
  },
  header: {
    application: '應用程式',
    configApplication: '配置',
    createApp: '創建應用程式',
    createProfile: '創建您的設定檔',
    dashboard: '儀表板',
    division: 'Suites',
    editApp: '編輯應用程式',
    endUser: '應用程式用戶',
    forgotPassword: '忘記密碼',
    general: '一般',
    login: '登入到您的帳戶',
    project: '項目',
    resetPassword: '重設密碼',
    setting: '設定',
    signin: '登入',
    user: '用戶',
    tutorial: '教學',
    genToken: '生成權杖',
    loginAuthorization: '登入',
    verifyToken: '權杖驗證',
    decodedToken: '解碼權杖',
    accessToken: '使用權杖',
    client: '客戶',
    createClient: '創建客戶',
    editClient: '編輯客戶',
  },
  label: {
    project: '項目',
    division: 'Suite',
    user: '用戶',
    application: '應用程式',
    configApplication: '配置',
    accessTokenLifeSpan: '使用權杖的有效期限',
    authenticatorType: '驗證器類型',
    changePassword: '更改密碼',
    clientId: '客戶ID',
    clientSecret: '客戶密鑰',
    company: '公司',
    confirmNewPassword: '確認新密碼',
    confirmPassword: '確認密碼',
    copyright: 'Copyright © 2022 Transcosmos inc. All rights reserved.',
    createApp: '創建應用程式',
    createDivision: 'Create Suite',
    createEndUser: '創建應用程式用戶',
    createProject: '創建項目',
    createUser: '創建用戶',
    currentPassword: '目前密碼',
    divisionAdmin: 'Suite Admin',
    editApp: '編輯應用程序',
    editDivision: 'Edit Suite',
    editEndUser: '編輯應用用戶',
    editProject: '編輯項目',
    editUser: '編輯用戶',
    email: '電子郵件',
    endUser: '應用程式用戶',
    errorLogs: '錯誤日誌',
    errorLogsInThisWeek: '本週錯誤日誌',
    examples: '例子',
    firstName: '名字',
    id: 'ID',
    idAccessTokenLifeSpan: 'ID使用權杖的有效期限',
    lastName: '姓氏',
    logStatistics: '日誌統計',
    name: '姓名',
    newPassword: '新密碼',
    note: '筆記',
    password: '密碼',
    redirectUrl: '重定向網址',
    refreshTokenLifeSpan: '刷新使用權杖的有效期限',
    region: '地區',
    role: '權限',
    scopeName: '範圍名稱',
    scopes: '範圍',
    successLogs: '成功日誌',
    successLogsInThisWeek: '本週成功日誌',
    superAdmin: '超級管理員',
    systemUser: '系統人員',
    minutes: '分鐘',
    times: '次數',
    totalLogsInThisWeek: '本週總日誌',
    url: '網址',
    whitelist: '公共IP白名單/網域',
    yourProfile: '您的個人資料',
    publicIp: '公共IP',
    domain: '網域',
    status: '狀態',
    codeChallenge: '代碼挑戰',
    codeChallengeMethod: '代碼挑戰方法',
    codeVerifier: '代碼驗證器',
    code: '代碼',
    accessToken: '使用權杖',
    client: '客戶',
  },
  message: {
    acceptHttps: '只接受https',
    alreadyHaveAccount: '已經有登入ID和密碼',
    changePasswordSuccess: '變更密碼成功。',
    create: '創建{name}成功。',
    delete: '您確認要刪除嗎？',
    destroy: '刪除{name}成功。',
    forgotPasswordSuccess:
      '檢查您的電子郵件以獲取重置密碼的連結。 如果它沒有在幾分鐘內出現，請檢查您的垃圾郵件資料夾。',
    list: '獲取列表{name}成功。',
    noData: '無數據',
    noRecordFound: '沒有發現紀錄',
    noteWhitelist: '如果您想允許所有公共IP白名單/網域，只需輸入 *',
    resetPasswordSuccess: '重置密碼成功。',
    update: '更新{name}成功 。',
    updateProfileSuccess: '更新個人資料成功。',
    easyManagement: '高效的管理，就這麼簡單！',
    resetPassword: '請問您確定要重置密碼嗎？',
    copySuccess: '使用權杖已被複製',
    copyDecodeSuccess: '解碼權杖已被複製。',
  },
  paging: {
    next: '下一頁',
    prev: '前一頁',
    records: '紀錄',
    rows: '{rows} 行',
  },
  placeholder: {
    inputConfirmNewPassword: '請輸入您確認的新密碼',
    inputConfirmPassword: '請輸入您確認的密碼',
    inputCurrentPassword: '請輸入您現有的密碼',
    inputEmail: '請輸入您的電子郵件',
    inputFirstName: '請輸入您的名字',
    inputLastName: '請輸入您的姓氏',
    inputName: '請輸入您的{name}姓名',
    inputFieldName: '請輸入您的姓名',
    inputNewPassword: '請輸入您新的密碼',
    inputPassword: '請輸入您的密碼',
    inputRedirectUrl: '請輸入重定向網址',
    inputScope: '請輸入範圍的名稱',
    inputWhiteList: '請輸入公共IP/網域',
    searchCompany: '請選擇公司',
    searchRegion: '請選擇區域',
    selectApplication: '請選擇應用程序',
    selectAuthenticatorType: '請選擇驗證器類型',
    selectDivision: 'Please select suite',
    selectProject: '請選擇項目',
    inputCodeChallenge: '請輸入代碼挑戰',
    inputCodeChallengeMethod: '請輸入代碼挑戰方法',
    inputCodeVerifier: '請輸入代碼驗證器',
  },
  title: 'ATM',
  validation: {
    confirmPass: '您的確認密碼於密碼不吻合',
    email: {
      format: '請輸入正確的電子郵件',
    },
    incorrect: '這個{field}不正確',
    max: '這個{field}必須少過{max}的字元',
    min: '這個{field}必須至少有{min}個字元',
    passwordRule: '密碼必須至少含有一個大寫的拉丁字母(A-Z)',
    positive: '這個{field}欄目必須是正數',
    required: '這個{field}是必填欄目',
    timeLifeSpanRefreshToken: '時間需要超過0',
    timeLifeSpanAccessToken: '您輸入的時間值必須大於 0 且小於 601。',
  },
}
